/**
 * Rutas POS donde el topbar debe mostrar el buscador de catálogo
 * (Venta y Pedidos → cuenta / draft; no la bandeja /pos/pedidos).
 */
export function isPosProductCatalogSearchUrl(url: string): boolean {
  const path = (url.split('?')[0] ?? url).split('#')[0] ?? '';
  if (
    path === '/pos/venta' ||
    path.startsWith('/pos/venta/') ||
    path === '/sales/pos/venta' ||
    path.startsWith('/sales/pos/venta/')
  ) {
    return true;
  }
  // /pos/pedidos/nuevo | /pos/pedidos/:draftId — no /pos/pedidos
  return /^\/(?:pos|sales\/pos)\/pedidos\/[^/]+$/.test(path);
}
